import React from 'react';
import { Row, Col } from 'reactstrap';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import { Home } from 'react-feather';

import { NewInternalBasePoint } from '../../../../Common/BaseEsPoints/InternalEsBasePoint';

export default function BreadCrumbComponent() {
  const search = useLocation().search;
  const commit = new URLSearchParams(search).get("commit");
  return (
    <div className='page-title'>
      <Row className=''>
        <Col xs="6">
          <h3>Internal Dashboard</h3>
        </Col>
        <Col xs="6">
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to={'/internal'}>
                <Home />
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              {commit === 'Get Data' ? <a href={`${NewInternalBasePoint}/rss_process/new`}>RSS Processes</a> : 'RSS Processes'}
            </BreadcrumbItem>
            {commit === 'Get Data' && <BreadcrumbItem className="fw-bold">
              Search
            </BreadcrumbItem>}
          </Breadcrumb>
        </Col>
      </Row>
    </div>
  )
}
